import { FC } from 'react';

export const PartnerEVSavings: FC = () => {
  return <section>EV Savings</section>;
};
